import { render, staticRenderFns } from "./MarketplacePricingTerm.vue?vue&type=template&id=12b7ba04&scoped=true&"
import script from "./MarketplacePricingTerm.vue?vue&type=script&lang=js&"
export * from "./MarketplacePricingTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b7ba04",
  null
  
)

export default component.exports